function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 191,
  width: 44,
  height: 31,
  rx: 6,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M214.641 10.5168L212.406 11.0097V9.14779L214.641 8.66406V10.5168ZM205.558 9.72278L203.385 10.1974L203.376 17.5081C203.376 18.8589 204.365 19.8537 205.683 19.8537C206.413 19.8537 206.947 19.7168 207.241 19.5525V17.6997C206.956 17.8184 205.549 18.2382 205.549 16.8874V13.6474H207.241V11.7033H205.549L205.558 9.72278ZM229.343 15.7283C229.343 13.3918 228.239 11.5482 226.128 11.5482C224.009 11.5482 222.727 13.3918 222.727 15.7101C222.727 18.4573 224.24 19.8446 226.413 19.8446C227.473 19.8446 228.274 19.5982 228.88 19.2513V17.4259C228.274 17.7363 227.58 17.9279 226.698 17.9279C225.834 17.9279 225.069 17.6176 224.971 16.5406H229.325C229.325 16.4903 229.328 16.376 229.332 16.2444L229.332 16.2435L229.332 16.2425C229.337 16.064 229.343 15.8541 229.343 15.7283ZM224.944 14.8613C224.944 13.8299 225.558 13.401 226.119 13.401C226.662 13.401 227.241 13.8299 227.241 14.8613H224.944ZM200.296 13.5287C199.824 13.5287 199.539 13.6657 199.539 14.0216C199.539 14.4102 200.029 14.5812 200.637 14.7933C201.629 15.1391 202.935 15.5942 202.94 17.2799C202.94 18.9137 201.667 19.8537 199.815 19.8537C199.049 19.8537 198.212 19.6986 197.384 19.3335V17.1613C198.132 17.5811 199.076 17.8914 199.815 17.8914C200.313 17.8914 200.67 17.7545 200.67 17.3347C200.67 16.9042 200.138 16.7074 199.496 16.4699C198.519 16.1081 197.286 15.6517 197.286 14.1311C197.286 12.5157 198.488 11.5482 200.296 11.5482C201.035 11.5482 201.765 11.6668 202.504 11.968V14.1129C201.827 13.7387 200.972 13.5287 200.296 13.5287ZM210.011 12.3787L209.868 11.7033H207.945V19.6894H210.171V14.2771C210.696 13.5744 211.587 13.7021 211.863 13.8025V11.7033C211.578 11.5938 210.536 11.393 210.011 12.3787ZM212.406 11.7034H214.641V19.6894H212.406V11.7034ZM217.544 12.2601C217.856 11.968 218.417 11.5482 219.289 11.5482C220.848 11.5482 222.317 12.9902 222.326 15.6371C222.326 18.5303 220.874 19.8446 219.28 19.8446C218.497 19.8446 218.025 19.5069 217.704 19.2696L217.695 21.8525L215.469 22.3363V11.6942H217.428L217.544 12.2601ZM217.704 17.4077C217.918 17.645 218.23 17.8366 218.755 17.8366C219.574 17.8366 220.126 16.9239 220.126 15.7009C220.126 14.5053 219.565 13.5744 218.755 13.5744C218.247 13.5744 217.927 13.7569 217.695 14.0216L217.704 17.4077Z",
  fill: "#6461FC"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 144,
  width: 43,
  height: 31,
  rx: 6,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M168.688 15.6639C168.688 20.5883 164.935 24.5803 160.305 24.5803C155.674 24.5803 151.921 20.5883 151.921 15.6639C151.921 10.7395 155.674 6.74756 160.305 6.74756C164.935 6.74756 168.688 10.7395 168.688 15.6639Z",
  fill: "#ED0006"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M179.564 15.6639C179.564 20.5883 175.811 24.5803 171.18 24.5803C166.55 24.5803 162.797 20.5883 162.797 15.6639C162.797 10.7395 166.55 6.74756 171.18 6.74756C175.811 6.74756 179.564 10.7395 179.564 15.6639Z",
  fill: "#0099DF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M165.743 8.87744C167.545 10.5129 168.688 12.9464 168.688 15.6638C168.688 18.3812 167.545 20.8147 165.743 22.4501C163.94 20.8147 162.797 18.3812 162.797 15.6638C162.797 12.9464 163.94 10.5129 165.743 8.87744Z",
  fill: "#6C6BBD"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 95,
  width: 45,
  height: 31,
  rx: 6,
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.821 22.1612C116.289 23.4894 114.302 24.2912 112.131 24.2912C107.285 24.2912 103.357 20.2992 103.357 15.3749C103.357 10.4505 107.285 6.4585 112.131 6.4585C114.302 6.4585 116.289 7.2603 117.821 8.58849C119.353 7.2603 121.341 6.4585 123.512 6.4585C128.358 6.4585 132.286 10.4505 132.286 15.3749C132.286 20.2992 128.358 24.2912 123.512 24.2912C121.341 24.2912 119.353 23.4894 117.821 22.1612Z",
  fill: "#ED0006"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.821 22.1612C119.708 20.5258 120.904 18.0923 120.904 15.3749C120.904 12.6574 119.708 10.2239 117.821 8.58849C119.353 7.2603 121.341 6.4585 123.512 6.4585C128.358 6.4585 132.286 10.4505 132.286 15.3749C132.286 20.2992 128.358 24.2912 123.512 24.2912C121.341 24.2912 119.353 23.4894 117.821 22.1612Z",
  fill: "#F9A000"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.821 22.161C119.708 20.5256 120.904 18.0921 120.904 15.3747C120.904 12.6573 119.708 10.2238 117.821 8.58838C115.935 10.2238 114.739 12.6573 114.739 15.3747C114.739 18.0921 115.935 20.5256 117.821 22.161Z",
  fill: "#FF5E00"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  width: 43,
  height: 31,
  rx: 6,
  fill: "#1F72CD"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.7089 10.979L51.6857 20.3394H56.502L57.0991 18.8469H58.4639L59.061 20.3394H64.3624V19.2003L64.8347 20.3394H67.577L68.0494 19.1762V20.3394H79.0749L80.4155 18.8857L81.6708 20.3394L87.3337 20.3514L83.2979 15.6853L87.3337 10.979H81.7587L80.4536 12.4058L79.2378 10.979H67.2436L66.2136 13.395L65.1595 10.979H60.3533V12.0793L59.8186 10.979H55.7089ZM72.1731 12.3082H78.5045L80.4409 14.5074L82.4398 12.3082H84.3763L81.434 15.684L84.3763 19.0209H82.352L80.4155 16.7962L78.4065 19.0209H72.1731V12.3082ZM73.7366 14.925V13.6989V13.6977H77.6872L79.411 15.6586L77.6108 17.6302H73.7366V16.2916H77.1906V14.925H73.7366ZM56.6408 12.3082H58.9885L61.6571 18.6555V12.3082H64.2289L66.29 16.8592L68.1896 12.3082H70.7486V19.0249H69.1915L69.1788 13.7617L66.9087 19.0249H65.5159L63.2331 13.7617V19.0249H60.0299L59.4226 17.5191H56.1418L55.5357 19.0236H53.8195L56.6408 12.3082ZM56.702 16.1271L57.7829 13.4446L58.8625 16.1271H56.702Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 31,
  rx: 6,
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3575 21.0001H10.6919L8.69308 13.165C8.5982 12.8046 8.39676 12.4859 8.10044 12.3358C7.36095 11.9584 6.54608 11.658 5.65714 11.5066V11.2049H9.95112C10.5438 11.2049 10.9882 11.658 11.0623 12.1843L12.0994 17.836L14.7637 11.2049H17.3551L13.3575 21.0001ZM18.8367 21.0001H16.3193L18.3922 11.2049H20.9096L18.8367 21.0001ZM24.1665 13.9185C24.2406 13.3909 24.6851 13.0893 25.2036 13.0893C26.0185 13.0135 26.9061 13.165 27.6469 13.5411L28.0914 11.4321C27.3506 11.1305 26.5357 10.979 25.7962 10.979C23.3529 10.979 21.575 12.3358 21.575 14.2188C21.575 15.6513 22.8344 16.4035 23.7233 16.8566C24.6851 17.3084 25.0555 17.6101 24.9814 18.0619C24.9814 18.7397 24.2406 19.0413 23.5011 19.0413C22.6121 19.0413 21.7232 18.8154 20.9096 18.438L20.4652 20.5483C21.3541 20.9243 22.3158 21.0758 23.2048 21.0758C25.9444 21.1503 27.6469 19.7948 27.6469 17.7603C27.6469 15.1982 24.1665 15.048 24.1665 13.9185V13.9185ZM36.4571 21.0001L34.4583 11.2049H32.3113C31.8668 11.2049 31.4224 11.5066 31.2742 11.9584L27.5728 21.0001H30.1643L30.6816 19.5689H33.8657L34.162 21.0001H36.4571ZM32.6817 13.8427L33.4212 17.5344H31.3483L32.6817 13.8427Z",
  fill: "#172B85"
});

function SvgTakeAChefPaymentMethods(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 31,
    viewBox: "0 0 235 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAChefPaymentMethods);
export default __webpack_public_path__ + "static/media/take-a-chef-payment-methods.0237be76c0d082f7eddfc321214230a8.svg";
export { ForwardRef as ReactComponent };